import { Component } from '@grafikr/components';
import { NonNullish } from 'utils/nullish-check';

export default Component((node) => {
  const button = NonNullish(node.querySelector('[data-button]'));
  const icons = node.querySelectorAll<HTMLElement>('[data-icon]');
  const content = NonNullish(node.querySelector<HTMLElement>('[data-content]'));

  const toggleIcons = () => {
    icons.forEach((icon) => {
      icon.hidden = !icon.hidden;
    });
  };

  const toggle = (shouldOpen: boolean) => {
    const isOpen = button.ariaExpanded === 'true';
    content.hidden = !shouldOpen;
    button.ariaExpanded = shouldOpen ? 'true' : 'false';

    if (shouldOpen !== isOpen) {
      toggleIcons();
    }
  };

  button.addEventListener('click', () => toggle(button.ariaExpanded === 'false'));
  node.addEventListener('open', () => toggle(true));
  node.addEventListener('close', () => toggle(false));
});
